document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".flex-layout.afbeelding_accordeon-layout").forEach((layout) => {
        const boxes = [...layout.querySelectorAll(".bz-info-box")];
        if (!boxes.length) return;

        const setOpen = (box, open) => {
            box.classList.toggle("open", open);
            box.querySelector(".box-toggle")?.setAttribute("aria-expanded", String(open));

            const panel = box.querySelector(".bz-info-inner");
            if (panel) panel.inert = !open;
        };

        boxes.forEach((box) => {
            setOpen(box, false);

            box.querySelector(".box-toggle")?.addEventListener("click", () => {
                const isOpen = box.classList.contains("open");
                boxes.forEach((other) => setOpen(other, false));
                if (!isOpen) setOpen(box, true);
            });
        });

        setOpen(boxes[0], true);
    });
});
